import { store } from "@/lib/store";
import { ChatbotNotificationService } from "@/services/NotificationService";
import { useMemo } from "react";

export function useNotificationService() {
  const NotificationsService = useMemo(
    () => new ChatbotNotificationService(store!),
    [],
  );

  return {
    NotificationsService,
  };
}
